export enum CustomChannelDataEnum {
  favouritePositions = 'favouritePositions',
  favouriteMicroventilationPosition = 'favouriteMicroventilationPosition',
}